import styled from 'styled-components';
import { SubmitButton as _SubmitButton } from 'formik-antd';
import { Button as _Button, Select as _Select } from 'antd';

export const PhoneRegionSelect = styled(_Select)`
  width: 104px;
  min-width: 104px;

  .ant-select-selector {
    padding: 0 28px 0 12px !important;
    border: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .ant-select-selection-item {
    padding-right: 0 !important;
  }

  .ant-select-arrow {
    right: 10px;
  }
`;

export const SubmitButton = styled(_SubmitButton)`
  width: 100%;
  margin: 24px 0;
`;

export const FullWidthButton = styled(_Button)`
  width: 100%;
  margin: 24px 0;
`;
